import { Tooltip } from "antd";
import { STATUS_DEFINITIONS } from "../../constants/overview";
import { RoundedSelect } from "../tailwind/atoms";
import OpdIcon from "./OpdIcon";

const StatusDataTable = ({ title, rows = [], loading = false, servicesMap = {}, currentService, handleServiceChange = () => { } }) => {
  const columns = ["Status", "#Claims", "Claimed Amount", "Settled Amount"];
  const skeletonRows = 4;

  const formatCurrency = (num) => {
    if (!num || isNaN(num)) return "-";
    return "₹" + num.toLocaleString("en-IN", { maximumFractionDigits: 0 });
  };

  // Calculate totals
  const totals = rows.reduce(
    (acc, row) => {
      acc.claims += row.total_count || 0;
      acc.claimed += row.claim_amount || 0;
      acc.incurred += row.incurred_amount || 0;
      return acc;
    },
    { claims: 0, claimed: 0, incurred: 0 }
  );

  return (
    <div className="mb-6 flex flex-col gap-3">
      {/* Title + Icon */}
      <div className="mb-4 flex items-start justify-between gap-4">
        <div className="mb-4 flex items-center gap-2">
          <OpdIcon name="status" className="mb-2 h-6 w-6 rounded border border-blue-200 bg-blue-100 p-1.5 text-blue-700" />
          <h2 className="text-lg font-fig-semibold leading-tight text-gray-900">{title}</h2>
        </div>
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
          <RoundedSelect
            listClasses="w-34"
            selectOptions={Object.values(servicesMap)}
            selectValues={Object.keys(servicesMap).map((_, i) => i)}
            curvalue={servicesMap[currentService] || 'Overall'}
            selectHandler={(index) =>
              handleServiceChange('status_split', Object.keys(servicesMap)[index])
            }
          />
        </div>
      </div>

      <div className="overflow-x-auto rounded-lg border border-gray-300 bg-white">
        <table className="w-full table-auto border-collapse text-left text-xs">
          <thead>
            <tr>
              {columns.map((col, idx) => (
                <th
                  key={idx}
                  className="relative border-b border-gray-300 bg-gray-50 px-4 py-2.5 text-left text-2xs font-bold uppercase tracking-widest text-gray-600"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loading
              ? Array.from({ length: skeletonRows }).map((_, idx) => (
                <tr key={idx} className="animate-pulse bg-gray-50">
                  {columns.map((_, cIdx) => (
                    <td key={cIdx} className="py-3 px-4 text-sm">
                      <div className="h-4 w-3/4 rounded bg-gray-300"></div>
                    </td>
                  ))}
                </tr>
              ))
              : rows.length > 0 ? rows.map((row, idx) => (
                <tr
                  key={idx}
                  className="transition-colors duration-200 hover:bg-gray-50"
                >
                  <td className="border-b border-gray-200 px-4 py-3 text-xs font-fig-normal text-gray-900">
                    <Tooltip title={STATUS_DEFINITIONS[row.bucket_status] || ""}>
                      {row.bucket_status}
                    </Tooltip>
                  </td>
                  <td className="border-b border-gray-200 px-4 py-3 text-xs font-jetbrains-mono tabular-nums text-gray-700">
                    {(row.total_count).toLocaleString("en-IN", { maximumFractionDigits: 0 })}
                  </td>
                  <td className="border-b border-gray-200 px-4 py-3 text-xs font-jetbrains-mono tabular-nums text-gray-900">
                    {formatCurrency(row.claim_amount)}
                  </td>
                  <td className="border-b border-gray-200 px-4 py-3 text-xs font-jetbrains-mono tabular-nums text-gray-900">
                    {formatCurrency(row.incurred_amount)}
                  </td>
                </tr>
              )) : (
                <tr>
                  <td colSpan={columns.length} className="px-4 py-8 text-center text-sm text-gray-500 font-fig-normal">
                    No results found
                  </td>
                </tr>
              )}

            {/* Total Row */}
            {!loading && rows.length > 0 && (
              <tr className="border-t border-gray-300 bg-blue-100 font-fig-semibold text-gray-900">
                <td className="px-4 py-3 text-sm">Total</td>
                <td className="px-4 py-3 text-xs font-jetbrains-mono tabular-nums">{(totals.claims).toLocaleString("en-IN", { maximumFractionDigits: 0 })}</td>
                <td className="px-4 py-3 text-xs font-jetbrains-mono tabular-nums">
                  {formatCurrency(totals.claimed)}
                </td>
                <td className="px-4 py-3 text-xs font-jetbrains-mono tabular-nums">
                  {formatCurrency(totals.incurred)}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StatusDataTable;
